import { UserType } from '@repo/shared/types';
import { type LoaderFunctionArgs, redirect } from 'react-router';
import { AuthenticatedLayout } from '@/components/layout/authenticated';
import { getSession } from '@/lib/auth-req';

const loader = async ({ request }: LoaderFunctionArgs) => {
  const session = await getSession(request);
  if (!session.isAuthenticated || !session.user || session.user.type !== UserType.ADMIN) {
    return redirect('/auth/signin');
  }
  if (session.user.type === UserType.ADMIN) {
    redirect('/admin/organizations');
  }
};

export { loader as adminLoader };

export const AdminLayout = AuthenticatedLayout;
